import useAdmin from "./Admin.hook";

export default useAdmin;
